import { Input, InputProps } from 'components/Blocks';
import { forwardRef, ReactNode } from 'react';
import { cn } from 'styles';

type IconInputProps = InputProps & {
  children?: never;
  icon: ReactNode;
  containerClassName?: string;
};

export const IconInput = forwardRef<HTMLInputElement, IconInputProps>(
  ({ icon, className, containerClassName, ...props }: IconInputProps, ref) => {
    return (
      <div className={cn('relative w-full', containerClassName)}>
        <div className="absolute left-3 top-1/2 -translate-y-1/2">{icon}</div>

        <Input ref={ref} className={cn('pl-10', className)} {...props} />
      </div>
    );
  },
);

IconInput.displayName = 'IconInput';
